import type { useNavigate } from "@tanstack/react-router";

/**
 * Return to the form that sent us to an editor (round 4): in-app navigation
 * keeps the draft and the SPA alive. `back` is the form's path
 * (/add, /item/<id>?edit=1, or /shelf for a bulk edit); otherwise the editor's own parent.
 */
export function goBackTo(nav: ReturnType<typeof useNavigate>, back: string | undefined, fallback: "/settings" | "/settings/shelf") {
  const m = back?.match(/^\/item\/([0-9a-f-]{36})/);
  if (m) return nav({ to: "/item/$id", params: { id: m[1]! }, search: { edit: "1" } as never });
  if (back === "/add") return nav({ to: "/add" });
  if (back === "/shelf") return nav({ to: "/shelf" }); // a bulk edit in progress (D-37): the selection is waiting there
  if (back?.startsWith("/settings/places/")) return nav({ to: "/settings/places/$id", params: { id: back.slice("/settings/places/".length) } });
  return nav({ to: fallback });
}
